function appendWireParam(url) {
  if (/[?&]wire=blob\b/.test(url)) return url;
  return url.includes('?') ? `${url}&wire=blob` : `${url}?wire=blob`;
}

function normalizeLoadedSnapshot(snapshot) {
  if (!snapshot || typeof snapshot !== 'object') return snapshot;

  const ds = snapshot.dataset;
  if (!ds || typeof ds !== 'object') return snapshot;

  if (ds.fiatSectionAudit && !ds.usFiatAudit) {
    return {
      ...snapshot,
      dataset: {
        ...ds,
        usFiatAudit: ds.fiatSectionAudit,
      },
    };
  }

  return snapshot;
}

async function gunzipToUtf8(bytes) {
  if (typeof DecompressionStream === 'undefined') {
    throw new Error('GUNZIP_NOT_SUPPORTED');
  }

  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
  return new Response(stream).text();
}

async function decodeSnapshotWireResponse(res) {
  const format = res.headers.get('X-Snapshot-Format') || 'json_gzip_v1';

  if (format === 'v8_gzip_v1') {
    const err = new Error(
      'Snapshot uses a legacy server format. Please recalculate the dataset.'
    );
    err.code = 'SNAPSHOT_REQUIRES_RECALC';
    throw err;
  }

  const bytes = new Uint8Array(await res.arrayBuffer());
  const jsonText = await gunzipToUtf8(bytes);
  return normalizeLoadedSnapshot(JSON.parse(jsonText));
}

function isSnapshotWireResponse(res) {
  const contentType = res.headers.get('Content-Type') || '';
  return (
    contentType.includes('application/vnd.v3tax.snapshot+gzip') ||
    !!res.headers.get('X-Snapshot-Wire')
  );
}

export async function fetchDatasetSnapshotWire(url, options = {}) {
  const { fetchImpl = fetch, ...fetchOptions } = options;
  const wireUrl = appendWireParam(url);
  const res = await fetchImpl(wireUrl, fetchOptions);

  if (!res.ok) {
    const payload = await res.json().catch(() => null);
    const err = new Error(payload?.message || payload?.error || `Snapshot fetch failed: ${res.status}`);
    err.code = payload?.code || payload?.error || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }

  if (isSnapshotWireResponse(res)) {
    return decodeSnapshotWireResponse(res);
  }

  const payload = await res.json().catch(() => null);
  if (!payload?.success || !payload?.snapshot) {
    const err = new Error(payload?.error || 'Snapshot payload invalid');
    err.code = payload?.code || payload?.error || 'SNAPSHOT_LOAD_FAILED';
    throw err;
  }

  return normalizeLoadedSnapshot(payload.snapshot);
}
